<template>
  <div>
    <h4>Читайте также:</h4>
    <div class="persons" v-if="$resize && $mq.above(768)">
        <div class="person" @click="linkTo('svetlana')" v-if="contains('svetlana')">
          <div class="person-image person-1"></div>
          <div class="person-text person-1">Погуляйте <br>
            на свадьбе
          </div>
        </div>
        <div class="person" @click="linkTo('elena')" v-if="contains('elena')">
          <div class="person-image person-2"></div>
          <div class="person-text person-2">Пройдите
            <br>
            собеседование
          </div>
        </div>
        <div class="person" @click="linkTo('maria')" v-if="contains('maria')">
          <div class="person-image person-3"></div>
          <div class="person-text person-3">Отправьтесь
            <br>
            в путешествие
          </div>
        </div>
    </div >
    <ReadMoreMobile data-aos="fade-up" v-if="$resize && $mq.below(767)" :persons="persons" />

  </div>
</template>

<script>
  import ReadMoreMobile  from '../components/ReadMoreMobile'
    export default {
        name: "ReadMore",
        props:['persons'],
        data(){
            return {

            }
        },
        methods:{
            contains(person){
              return  this.persons.indexOf(person) !== -1
            },
            linkTo(name){
                this.$router.push(name)
            }
        },
        components:{
            ReadMoreMobile
        }
    }
</script>

<style scoped lang="scss">
  h4{
    margin-top: 50px;
    font-family: 'Playfair Display', serif;
    color: rgba(50, 50, 50, 0.9);
    font-size: 36px; /* Приближение из-за подстановки шрифтов */
    font-weight: 700;
    font-style: italic;
  }
  .persons {
    max-width: 830px;
    width: 65vw;
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    padding-bottom: 6vh;
    margin-top: 45px;
  }
  .person {
    cursor: pointer;
    .person-text {
      font-family: 'Playfair Display', serif;
      color: #323232;
      font-style: italic;
      text-align: left;
      background-repeat: no-repeat;
      background-size: auto 100%;
      padding-bottom: 17px;
      padding-top: 12px;
      display: block;
      margin: auto;
      font-size: 33px;
      line-height: 33px;
      &.person-1 {
        background-image: url("../assets/img/index/1-d.png");
        width: 165px;
        margin-left: 12px;
      }
      &.person-2 {
        background-image: url("../assets/img/index/2.png");
        width: 174px;
      }
      &.person-3 {
        background-image: url("../assets/img/index/3.png");
        width: 236px;
        margin-right: -20px;
      }

    }
    .person-image {
      background-repeat: no-repeat;
      background-size: contain;
      min-height: 340px;
      margin: 0 auto;
      &.person-1 {
        background-image: url("../assets/img/index/person1.png");
        width: 229px;
        height: 302px;
      }
      &.person-2 {
        background-image: url("../assets/img/index/person2.png");
        width: 229px;
        height: 302px;
      }
      &.person-3 {
        background-image: url("../assets/img/index/person3.png");
        width: 272px;
        height: 301px;
      }
    }
    &:hover {
      .person-text {
        &.person-1 {
          background-image: url("../assets/img/index/1-h.png");

        }
        &.person-2 {
          background-image: url("../assets/img/index/2-h.png");
        }
        &.person-3 {
          background-image: url("../assets/img/index/3-h.png");
        }
      }
      .person-image {
        filter: drop-shadow(0 0 15px rgba(255, 250, 145, 0.77));

      }
    }
  }

  @media screen and (max-width: 768px){
    h4{
      font-size: 20px;/* Приближение из-за подстановки шрифтов */
      line-height: 13px;/* Приближение из-за подстановки шрифтов */
      text-align: center;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ReadMore.vue